import React from "react";

import Layout from "@components/Layout/Layout";
import TestDriveUnavailable from "@components/TestDriveUnavailable/TestDriveUnavailable";

import {
  useConfigurationSelector,
  useTestDriveRedirectUrlSelector,
} from "@redux/reducers/appConfig";
import { IS_SERVER } from "@shared/constants";
import { getTestDriveRedirectUrl } from "@shared/v2/lib/getTestDriveRedirectUrl";

function getIsTestDriveAvailable(configuration) {
  return (
    configuration?.testDrive?.enabled &&
    configuration?.app?.discoveryJourney?.enabled
  );
}

export function withTestDriveGate(Component) {
  const WithTestDriveGateComponent = props => {
    const configuration = useConfigurationSelector();
    const redirectUrl = useTestDriveRedirectUrlSelector();

    if (redirectUrl) {
      return null;
    }

    if (!getIsTestDriveAvailable(configuration)) {
      return (
        <Layout isGetPageNameByPathname>
          <TestDriveUnavailable />
        </Layout>
      );
    }

    return <Component {...props} />;
  };

  WithTestDriveGateComponent.getInitialProps = async (ctx, ...args) => {
    const { appConfig } = ctx.store.getState();

    const redirectUrl = getTestDriveRedirectUrl(appConfig.configuration);

    if (redirectUrl) {
      if (IS_SERVER) {
        ctx.res.redirect(redirectUrl);
      } else {
        window.location.assign(redirectUrl);
      }

      return { namespacesRequired: ["common"] };
    }

    if (!getIsTestDriveAvailable(appConfig.configuration)) {
      return { namespacesRequired: ["common"] };
    }

    return Component.getInitialProps?.(ctx, ...args);
  };

  return WithTestDriveGateComponent;
}
